import {
  Button,
  Dialog,
  Divider,
  DialogTitle,
  DialogContent,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import useModal from "components/common/modals/modal/useModal";

const Modal = (props) => {
  const {
    color,
    content,
    onClose,
    maxWidth,
    modalTitle,
    buttonTitle,
    buttonStyle,
    buttonDisabled,
    buttonClass,
    buttonIcon,
    buttonVariant = "text",
  } = props;
  const { theme, isOpen, handleOpen, handleClose } = useModal();

  const handleModalClose = () => {
    handleClose();
    onClose && onClose();
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        className={buttonClass}
        sx={buttonStyle}
        variant={buttonVariant}
        color={color ?? "secondary"}
        disabled={buttonDisabled}
        startIcon={buttonIcon}
      >
        {buttonTitle}
      </Button>

      {isOpen && (
        <Dialog
          fullWidth={true}
          maxWidth={maxWidth ? maxWidth : "xs"}
          open={isOpen}
          onClose={handleModalClose}
          onClick={(e) => e.stopPropagation()}
          PaperProps={{
            sx: { overflowX: "hidden" },
          }}
        >
          <DialogTitle style={{ padding: "16px 24px" }}>
            <Box
              className="dialog-header"
              style={{ backgroundColor: theme.palette.background.paper }}
            >
              <div className="dialog-header__title">{modalTitle}</div>

              <Tooltip title="Close" placement="bottom">
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </DialogTitle>
          <Divider />
          <DialogContent>{content}</DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default Modal;
